import React from "react";
import Amplify from "aws-amplify";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import loader from '../../images/Spin-1s-107px.gif';
import { withAlert } from "react-alert";
import {
  getUserByIdentityKey,
  handleAcceptedService,
  clearServiceData
} from "../../Actions/actions";
import * as SecretKeys from "../../ENV.json";
import Header from "../Header/header";

Amplify.configure(SecretKeys.awsUserpool);
class ServiceAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      details: [],
      userTypeFooter: localStorage.getItem("userTypeFooter"),
      userId: localStorage.getItem("userId"),
      isLoader: false 
    };
  }

  componentDidMount() {
    const {
      match: { params }
    } = this.props;
    const { userId } = this.state;
    // console.log("siteId", params.siteKey, params);

    this.props.getUserByIdentityKey({
      userId,
      siteKey: params.siteKey,
      agreementId: params.siteId
    });
    // }


  }

  handleAccept = () => {
    this.setState({ isLoader: true });
    const { userId } = this.state;
    const {
      match: { params }
    } = this.props;
    this.props.handleAcceptedService({
      userId,
      agreementId: params.siteId
    });
  };

  componentDidUpdate() {
    const { acceptDocument } = this.props.data;
    const { history } = this.props;

    const { details } = this.state;
    if (acceptDocument !== undefined) {
      if (details !== acceptDocument) {
        if (acceptDocument === "OK") {
          localStorage.setItem("acceptedDocument", "false");

          history.push("/profile");
        }
        this.setState({
          details: acceptDocument
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.clearServiceData();
  }

  render() {
    
    const { userByIdentityKey } = this.props.data;
    let loader1;
    if (this.state.isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    return (
      <span>
        {loader1}
        <Header />
        <div className="section-content left-align term">
          <div className="row">
            <div className="col s12 m10 offset-m1">
              <div className="row">
                <div className="col s12">
                  {userByIdentityKey === "GONE" ? (
                    <div className="section-content center-align login-content">
                      <p>Sorry! Link has expired.</p>
                      <h5>
                        Click here to <Link to="/dashboard">Dashboard</Link>
                      </h5>
                    </div>
                  ) : (
                      <div>
                        <h4>{userByIdentityKey.result && userByIdentityKey.result.agreementTitle}</h4>
                        <div
                          className="content"
                          dangerouslySetInnerHTML={{
                            __html: userByIdentityKey.result && userByIdentityKey.result.agreementBody
                          }}
                        />
                        {userByIdentityKey.result && userByIdentityKey.result.agreementBody ? (
                          <button
                            onClick={this.handleAccept}
                            className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                            type="submit"
                            name="action"
                          >
                            Accept
                          <i className="material-icons">arrow_forward</i>
                          </button>
                        ) : (
                            ""
                          )}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

ServiceAgreement.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getUserByIdentityKey, handleAcceptedService, clearServiceData },
    dispatch
  );

export default withAlert(
  connect(mapStateToProps, mapDispatchToProps)(ServiceAgreement)
);
